module.exports = __webpack_public_path__ + "img/calendar_loader.671708ce.svg";